import { toast } from "react-hot-toast";
import { useLocation } from "wouter";
import { database } from "../../database.ts";
import { ConfirmDialog } from "../ConfirmDialog/ConfirmDialog.tsx";
import { useVehicleContext } from "./ModelContext.tsx";

export function DuplicateVehicleDialog() {
  const vehicle = useVehicleContext();
  const [_, navigate] = useLocation();

  return (
    <ConfirmDialog
      heading="Duplicate vehicle?"
      description={`${vehicle.name} will be duplicated. Clank!`}
      submitLabel="Duplicate"
      onSubmit={async () => {
        const nextVehicle = vehicle.gang.duplicateVehicle(vehicle);
        const result = await database.gangs.updateOne(nextVehicle.gang.data);
        return result.mapSuccess((gangId) => ({
          gangId,
          vehicleId: nextVehicle.id,
        }));
      }}
      onSuccess={({ gangId, vehicleId }) => {
        toast("Vehicle duplicated");
        navigate(`~/gangs/g/${gangId}/v/${vehicleId}`);
      }}
    />
  );
}
